export default {
  /**
   * @param name
   * @param data
   */
  downloadCsv(name, data) {
    const link = document.createElement('a');
    const date = (new Date()).toISOString().substring(0, 19);
    // encodeURIComponent, not encodeURI: encodeURI leaves "#" as it is, and the browser cuts
    // the file off there as the start of the link's fragment - a supplier reference like
    // "#49725" emptied the rest of the CSV.
    link.setAttribute('href', `data:text/csv;charset=utf-8,%EF%BB%BF${encodeURIComponent(data)}`);
    link.setAttribute(
      'download',
      `${name}_${date}.csv`,
    );
    document.body.appendChild(link);
    link.click();
  },
};



// WEBPACK FOOTER //
// ./src/services/download-service.js